/* eslint-disable jsx-a11y/label-has-associated-control */
import InputTextArea from "../../../../components/InputTextArea";
import { useTachDocWorkflow } from "../../../../context/TachDocumentContext";
import { StyledLabelTach } from "../../../../styles/pages/Workflows/InformationTach";

const JustifyTach = () => {
    const { justification, setJustification } = useTachDocWorkflow();
    const placeholder =
        "Insira sua justificativa com até 500 caracteres e envie para aprovação.";

    return (
        <>
            <StyledLabelTach htmlFor="justify">Justificativa</StyledLabelTach>
            <InputTextArea
                placeholder={placeholder}
                maxLength={500}
                id="justify"
                value={justification}
                onChange={(event: any) =>
                    setJustification(event.target.value as string)
                }
            />
        </>
    );
};

export default JustifyTach;
